import React from "react";
import { createHashRouter } from "react-router-dom";
import OfficeContainer from "../containers/OfficeContainer";
import AppContainer from "../containers/AppContainer";
import AuthorizedRoutes from "./AuthorizedRoutes";

/**
 * This replaces <HashRouter>
 * Still uses hash URLs (#/)
 */
export const appRouter = createHashRouter([
  {
    path: "*",
    element: (
      <OfficeContainer>
        <AppContainer>
          <AuthorizedRoutes />
        </AppContainer>
      </OfficeContainer>
    ),
  },
]);